import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AccessControlDeviceState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: AccessControlDeviceState = {
  data: [],
  isLoading: false,
  error: null,
};

const accessControlDeviceSlice = createSlice({
  name: 'accessControlDevices',
  initialState,
  reducers: {
    setAccessControlDevices: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setAccessControlDeviceLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setAccessControlDeviceError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setAccessControlDevices, setAccessControlDeviceLoading, setAccessControlDeviceError } =
  accessControlDeviceSlice.actions;

export default accessControlDeviceSlice.reducer;
